import styled from "styled-components";
import colors from "../../../constants/colors";

export const Container = styled("div")({
  background: `
    radial-gradient(circle at 20% 10%, rgba(116, 105, 182, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 90%, rgba(173, 136, 198, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(225, 175, 209, 0.03) 0%, transparent 70%),
    ${colors.BACKGROUND}
  `,
  borderRadius: "15px",
  padding: "1.5rem 1rem",
  color: colors.BLACK,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",
  textAlign: "center",
  direction: "rtl",
  minHeight: "50vh",
  justifyContent: "center",
});
